import { XIcon } from "lucide-react";
import { useEffect } from "react";

export const MODAL_SIZES = {
    SMALL: 'sm',
    MEDIUM: 'md',
    LARGE: 'lg'
}

const Modal = ({
    onClose,
    children,
    title,
    size = MODAL_SIZES.MEDIUM,
    expanded = true
}: {
    onClose: () => void;
    children: React.ReactElement;
    title?: string;
    size?: string;
    expanded?: boolean;
}) => {
    // Prevent background scrolling when modal is open
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start z-50 overflow-y-auto py-4">
            <div 
                className={`
                    bg-white rounded-lg w-full mx-4 my-auto flex flex-col
                    ${size === MODAL_SIZES.SMALL && 'max-w-xl'}
                    ${size === MODAL_SIZES.MEDIUM && 'max-w-2xl'}
                    ${size === MODAL_SIZES.LARGE && 'max-w-6xl'}
                `}
                style={{
                    height: expanded ? '80vh' : '60vh',
                    transition: 'height 0.8s cubic-bezier(0.2, 0, 0.2, 1)',
                    overflow: 'hidden'
                }}
            >
                <div className={`sticky top-0 bg-white p-4 border-b flex justify-between rounded-t-lg ${title ? 'mb-2' : ''} z-10`}>
                    <p className="font-bold text-2xl">
                        {title || ''}
                    </p>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
                        <XIcon />
                    </button>
                </div>
                <div className="overflow-y-auto p-4 flex-1">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;


// import { XIcon } from "lucide-react";

// export const MODAL_SIZES = {
//     SMALL: 'sm',
//     MEDIUM: 'md',
//     LARGE: 'lg'
// }

// const Modal = ({
//     onClose,
//     children,
//     title,
//     size = MODAL_SIZES.MEDIUM
// }: {
//     onClose: () => void;
//     children: React.ReactElement;
//     title?: string;
//     size?: string;
// }) => (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//         <div className={`
//             bg-white p-4 rounded-lg w-full
//             ${size === MODAL_SIZES.SMALL && 'max-w-xl'}
//             ${size === MODAL_SIZES.MEDIUM && 'max-w-2xl'}
//             ${size === MODAL_SIZES.LARGE && 'max-w-6xl'}
//         `}>
//             <div className={`flex justify-between ${title ? 'mb-4' : ''}`}>
//                 <p className="font-bold text-2xl">
//                     {title || ''}
//                 </p>
//                 <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
//                     <XIcon />
//                 </button>
//             </div>
//             {children}
//         </div>
//     </div>
// );

// export default Modal;
